import React from 'react';
import { ToastContext, Dropdown } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import RateModel from '../../../../models/rateModel';
import ContingentContainer from '../../contingentContainer';
import useAppContext from '../../../../context/useAppContext';
import ChartedEvent from '../../../../components/chartedEvent';
import PropTypes from 'prop-types';

export function ContingentAction({ objects: selectedRates, contingents, onSave }) {
    const [showModal, setShowModal] = React.useState(false);
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();
    const [{ event, organization }] = useAppContext();

    const editContingents = React.useCallback(
        ([contingentsToAdd, contingentsToDelete]) => {
            selectedRates.forEach(rate => {
                if (rate instanceof RateModel) {
                    //add key form_id , so that the backend does not delete the linked form
                    rate.form_id = rate.form;
                }
                //Add contingents to each rate
                rate.contingents.push(...contingentsToAdd);
                rate.contingents = new Set(rate.contingents);
                rate.contingents = Array.from(rate.contingents);
                //Delete contingents from each rate
                rate.contingents = rate.contingents.filter(contingent => !contingentsToDelete.includes(contingent));
                rate.translations = { name: {} };
            });
            RateModel.save(
                selectedRates,
                {
                    organizationId: organization.pk,
                    eventId: event.id
                },
                { skip_chart_validation: true }
            )
                .then(() => {
                    setShowModal(false);
                    toast.success(t(`ticket.rates.updateContingentSuccess`));
                    onSave();
                })
                .catch(e => {
                    setShowModal(false);
                    toast.error(t(`ticket.rates.updateContingentError`));
                });
        },
        [selectedRates, event, organization, onSave, setShowModal]
    );

    return (
        <React.Fragment>
            <ContingentContainer
                rates={selectedRates}
                onAccept={contingents => editContingents(contingents)}
                onClose={() => {
                    setShowModal(false);
                }}
                contingentsElements={contingents}
                showModal={showModal}
            />
            <ChartedEvent event={event}>
                <Dropdown.Item disabled={selectedRates?.some(rate => rate.category_is_ga)} onClick={() => setShowModal(true)}>
                    {t('ticket.rates.modifyContingent')}
                </Dropdown.Item>
            </ChartedEvent>
        </React.Fragment>
    );
}

ContingentAction.propTypes = {
    objects: PropTypes.array, //required
    contingents: PropTypes.array.isRequired,
    onSave: PropTypes.func.isRequired
};
